import React from 'react';
import { Button } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import './Banner.css';

interface BannerProps {
  isMobile?: boolean;
}

const Banner: React.FC<BannerProps> = ({ isMobile }) => {
  const { t } = useTranslation();

  const getBannerImage = () => {
    const today = new Date();
    const month = today.getMonth() + 1; // 1-12
    const day = today.getDate();
    const assetBase = `${process.env.PUBLIC_URL}/asset`;

    const isBetween = (
      m: number,
      d: number,
      startMonth: number,
      startDay: number,
      endMonth: number,
      endDay: number
    ) => {
      if (startMonth === endMonth) {
        return m === startMonth && d >= startDay && d <= endDay;
      }

      if (startMonth < endMonth) {
        return (
          m > startMonth || (m === startMonth && d >= startDay)
        ) && (
          m < endMonth || (m === endMonth && d <= endDay)
        );
      }

      return (
        m > startMonth || (m === startMonth && d >= startDay)
      ) || (
        m < endMonth || (m === endMonth && d <= endDay)
      );
    };

    if (isBetween(month, day, 1, 1, 1, 7)) {
      return `${assetBase}/banner-new-year.png`;
    }

    if (isBetween(month, day, 1, 20, 2, 20)) {
      return `${assetBase}/banner-tet-holiday.png`;
    }

    if (isBetween(month, day, 10, 25, 10, 31)) {
      return `${assetBase}/banner-haloween.png`;
    }

    if (isBetween(month, day, 12, 20, 12, 26)) {
      return `${assetBase}/banner-chrismast.png`;
    }

    return `${assetBase}/default-banner.jpg`;
  };

  const bannerStyle: React.CSSProperties = {
    backgroundImage: `url(${getBannerImage()})`,
  };

  const scrollToProducts = () => {
    const element = document.getElementById('trending-products');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const scrollToBottom = () => {
    const footer = document.querySelector('.app-footer');
    if (footer) {
      footer.scrollIntoView({ behavior: 'smooth', block: 'end' });
    } else {
      // Fallback: scroll to very large number
      window.scrollTo({
        top: 999999,
        behavior: 'smooth',
      });
    }
  };

  return (
    <div className="banner0" style={bannerStyle}>
      <div className="banner0-text-wrapper">
        <div className="banner0-title">
          <h1>{t('bannerTitle')}</h1>
        </div>
        <div className="banner0-content">
          {t('bannerContent', 'An efficient page animation solution')}
        </div>
        <Button ghost className="banner0-button" onClick={scrollToProducts}>
          {t('learnMore', 'Learn More')}
        </Button>
      </div>
      <div className="banner0-icon" onClick={scrollToBottom} style={{ cursor: 'pointer' }}>
        <DownOutlined />
      </div>
    </div>
  );
};

export default Banner;